class NcAccessApplication extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-nc-access-option]');
    this.groups = [...this.querySelectorAll('[data-nc-fields]')];
    if (!this.select) return;
    this.storageKey = 'nc-access-application-draft';
    const allowed = new Set(['infinity-complete', 'infinity-core', 'pay-as-you-go-test']);
    const requested = new URL(window.location.href).searchParams.get('option');
    const draft = this.readDraft();
    if (draft) this.restoreDraft(draft);
    if (allowed.has(requested)) this.select.value = requested;
    this.select.addEventListener('change', () => this.sync());
    this.addEventListener('input', () => this.saveDraft());
    this.addEventListener('change', () => this.saveDraft());
    this.sync();
  }

  readDraft() {
    try { return JSON.parse(sessionStorage.getItem(this.storageKey) || 'null'); }
    catch { return null; }
  }

  restoreDraft(draft) {
    for (const [name, value] of Object.entries(draft)) {
      const control = this.querySelector(`[name="${CSS.escape(name)}"]`);
      if (control && typeof value === 'string') control.value = value;
    }
  }

  saveDraft() {
    const form = this.querySelector('form');
    if (!form) return;
    const draft = {};
    for (const [name, value] of new FormData(form)) {
      if (name.startsWith('contact[') && typeof value === 'string') draft[name] = value;
    }
    try { sessionStorage.setItem(this.storageKey, JSON.stringify(draft)); }
    catch { /* Storage can be blocked; the native form still works. */ }
  }

  sync() {
    const payg = this.select.value === 'pay-as-you-go-test';
    for (const group of this.groups) {
      const show = group.dataset.ncFields === (payg ? 'pay-as-you-go-test' : 'unlimited');
      group.hidden = !show;
      for (const control of group.querySelectorAll('input, select, textarea')) {
        control.disabled = !show;
        if (control.dataset.required === 'true') control.required = show;
      }
    }
  }
}

if (!customElements.get('nc-access-application')) {
  customElements.define('nc-access-application', NcAccessApplication);
}
